// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionAccessStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var m = require('mobx');
  var accessFetcher = require('fetchers/Izenda.AccessDataFetcher');
  var AccessConstants = require('logic/data/Izenda.AccessConstants');
  var PermissionAccess = require('logic/models/Izenda.Access');

  function PermissionAccessStore(model) {
    var props = {
      model: model || new PermissionAccess()
    };
    this.accessOrigin = null;
    m.extendObservable(this, props);
  }

  /**
   * Load access for search/sort...
   * @param {object}    access data
   * @return {object} Promise
   */
  PermissionAccessStore.prototype.loadAllAccess = function (data) {
    var model = this.model;
    model.pageInfo.buildPagingRequest();

    return accessFetcher.loadAccesses(data, model.pageInfo).then(
      m.action(function (access) {
        this.model.populateAccessDetails(access);
        return Promise.resolve(true);
      }.bind(this))
    );
  };

  /**
   * Handle when page size change
   * @param {int}    page number
   * @return {object} Promise
   */
  PermissionAccessStore.prototype.onPageSizeChange = function (pageSize) {
    this.model.pageInfo.setPageSize(pageSize);
    return this.goToPage(1);
  };

  /**
   * Handle go to page
   * @param  {int} pageIndex
   * @return {object} Promise
   */
  PermissionAccessStore.prototype.goToPage = function (pageIndex) {
    var pageInfo = this.model.pageInfo;
    pageInfo.setPageIndex(pageIndex);
    return this.loadAllAccess(this.accessOrigin);
  };

  /**
   * Search subscription
   * @param  {string} searchProperty
   * @param  {string} searchText
   * @return {object} Promise
   */
  PermissionAccessStore.prototype.search = function (searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);
    return this.goToPage(1);
  };

  /**
    * Change sort orders
    * @param {string} columnKey
    * @param {object} sortDir
    * @return {object} Promise
    */
  PermissionAccessStore.prototype.onSortChange = function (columnKey, sortDir) {
    this.model.pageInfo.setColSortDirs(columnKey, sortDir);
    return this.loadAllAccess(this.accessOrigin);
  };

  /**
   * Update filter criteria information.
   * @param {String} searchProperty
   * @param {String} searchText
   */
  PermissionAccessStore.prototype.updateSearchCriteria = function (searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);
  };

  /**
   * Get all data for tenant access page
   * @param  {string} tenantId tennant id
   * @param  {object} data     current access
   * @return {object}          Promise
   */
  PermissionAccessStore.prototype.initialAccessGrid = m.action (function (data) {
    var model = this.model;
    model.pageInfo.buildPagingRequest();
    this.accessOrigin = data;

    return Promise.join(
      accessFetcher.loadAccesses(data, model.pageInfo),
      accessFetcher.loadTenantSettingAccessRight(AccessConstants.ACCESS_MODE.REPORT),
      accessFetcher.loadTenantSettingAccessRight(AccessConstants.ACCESS_MODE.DASHBOARD),
      m.action(function (access, reportAccessRights, dashboardAccessRights) {
        this.model.populateAccessDetails(access);
        this.model.populateReportAccessRight(reportAccessRights);
        this.model.populateDashboardAccessRight(dashboardAccessRights);
      }).bind(this)
    );
  });
  
  /**
   * Update access origin
   * @param  {array} data)
   */
  PermissionAccessStore.prototype.updateAccessOrigin = function (data) {
    this.accessOrigin = data;
  };

  PermissionAccessStore.prototype.updateModel = m.action (function (model) {
    this.model = model;
  });

  module.exports = PermissionAccessStore;
}());



// WEBPACK FOOTER //
// ./ui/logic/Izenda.PermissionAccessStore.js